
<template>
  <div class="freight-assumptions">
    <span class="adjust-section-title section-title hidden-xs-only">
      Adjust the freight assumptions
    </span>
    <span class="adjust-section-title section-title hidden-sm-and-up">
      Freight assumptions
    </span>

    <v-layout row pt-3>
      <delta-adjustment
        ident="percentOfRevenue"
        title="BY PERCENTAGE OF REVENUE"
        unit="%"
        :fixed-precision=2
        :value="percentageOfRevenue"
        :min=0
        :max=50.0
        :step=0.25
        :disabled="!revenueLinked"
        v-on:value-changed="updatePercentageOfRevenue"
        ref="percentOfRevenueAdjuster"
      ></delta-adjustment>

      <div class="vertical-separator"></div>

      <value-adjustment
        ident="inbound"
        title="INBOUND COST"
        :value="inboundCost"
        prefix="$"
        :accessory="revenueLinkIcon"
        :disabled="revenueLinked"
        v-on:accessory-selected="linkWasSelected"
        v-on:value-changed="updateInboundCost"
      ></value-adjustment>

      <div class="vertical-separator"></div>

      <value-adjustment
        ident="outbound"
        title="OUTBOUND COST"
        :value="outboundCost"
        prefix="$"
        :accessory="revenueLinkIcon"
        :disabled="revenueLinked"
        v-on:accessory-selected="linkWasSelected"
        v-on:value-changed="updateOutboundCost"
      ></value-adjustment>
    </v-layout>

  </div>
</template>

<script>
export default {
  name: 'freight-assumptions',
  data () {
    return {
      inboundPercentOfTrans: 0.33333,
    }
  },

  mounted() {
    this.updatePercentageOfRevenue({ val: this.freightAssumptions.percentageOfRevenue })
  },

  methods: {
    linkWasSelected() {
      let lockState = this.freightAssumptions
      lockState.percentageLocked = !lockState.percentageLocked
      this.$store.commit('setFreightAssumptions', lockState)

      if(lockState.percentageLocked) {
        this.updatePercentageOfRevenue({ val: this.freightAssumptions.percentageOfRevenue })
      }
    },
    updatePercentageOfRevenue(ev) {
      let current = this.freightAssumptions

      current.percentageOfRevenue = Number(ev.val),
      current.inboundCost = Number((this.inboundPercentOfTrans * (this.annualRevenue * (Number(ev.val) / 100))).toFixed(0)),
      current.outboundCost = Number((this.outboundPercentOfTrans * (this.annualRevenue * (Number(ev.val) / 100))).toFixed(0))

      this.$store.commit('setFreightAssumptions', current)
    },
    updateInboundCost(ev) {
      let update = this.freightAssumptions
      update.inboundCost = Number(ev.val)
      this.$store.commit('setFreightAssumptions', update)
    },
    updateOutboundCost(ev) {
      let update = this.freightAssumptions
      update.outboundCost = Number(ev.val)
      this.$store.commit('setFreightAssumptions', update)
    },
    resetAssumptionValues() {
      this.$store.commit('setFreightAssumptionsToDefault')
      this.$refs.percentOfRevenueAdjuster.enteredValueDidChange(this.percentageOfRevenue)
    }
  },

  computed: {
    freightAssumptions() {
      return this.$store.getters.freightAssumptions
    },
    revenueLinked() {
      return this.freightAssumptions.percentageLocked
    },
    annualRevenue() {
      return this.$store.getters.annualRevenue
    },
    revenueLinkIcon() {
      return this.revenueLinked ? "link" : "link_off"
    },
    percentageOfRevenue() {
      return this.freightAssumptions.percentageOfRevenue
    },
    inboundCost() {
      return this.freightAssumptions.inboundCost
    },
    outboundCost() {
      return this.freightAssumptions.outboundCost
    },
    outboundPercentOfTrans() {
      return 0.8666 - (0.05 * Math.pow(this.$store.getters.distributionCenterCount, 0.5))
    }
  },

  components: {
    'range-adjustment': () => import ('@/components/RangeAdjustment'),
    'delta-adjustment': () => import ('@/components/DeltaAdjustment'),
    'value-adjustment': () => import ('@/components/ValueAdjustment'),
  }
}

</script>


<style scoped>
a:hover {
  font-weight: bold;
}

.freight-assumptions {
  height: 100%;
}
.adjust-actions {
  display: inline-block;
  font-size: 10pt;
  position: absolute;
  right: 180px;
  top: 5px;
}
.section-title {
  text-align: left;
  padding-left: 10px;
  color: #444;
}
.adjust-section-title {
  font-weight: bold;
  font-size: 13pt;
}
.vertical-separator {
  width: 1px;
  height: 35px;
  background-color: #ccc;
  position: relative;
  top: 35px;
}

@media only screen and (max-width: 600px) {
  .adjust-actions {
    right: 5px;
  }
}

@media only screen and (max-height: 550px) {
  .adjust-actions {
    right: 5px;
  }
}

</style>